export const formatDate = (value: unknown): string => {
	if (typeof value === "string" && value.match(/^\d{4}-\d{2}-\d{2}T/)) {
		return new Date(value).toLocaleDateString("en-GB");
	}
	return String(value);
};

/**
 * Converts an ISO string or Date into DD-MM-YYYY format
 * @param input - A date string or Date object
 * @returns formatted date string or empty string
 */
export const formatDateDDMMYYYY = (input?: string | Date | null): string => {
	if (!input) return "";

	const date = typeof input === "string" ? new Date(input) : input;

	if (isNaN(date.getTime())) return ""; // invalid date fallback

	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();

	return `${day}-${month}-${year}`;
};

export const formatTimeNotifications = (isoDate: string): string => {
	const date = new Date(isoDate);
	const now = new Date();

	const isToday = date.toDateString() === now.toDateString();

	const hours = date.getHours();
	const minutes = date.getMinutes().toString().padStart(2, "0");
	const ampm = hours >= 12 ? "PM" : "AM";
	const formattedHour = hours % 12 === 0 ? 12 : hours % 12;

	const timeString = `${formattedHour}:${minutes} ${ampm}`;

	if (isToday) {
		return `Today at ${timeString}`;
	} else {
		const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		const month = monthNames[date.getMonth()];
		const day = date.getDate();
		const year = date.getFullYear();
		return `${month} ${day}, ${year} ${timeString}`;
	}
};

export const isDeadlineClose = (deadline: string) => {
	const deadlineDate = new Date(deadline);
	const today = new Date();
	const daysLeft = Math.ceil((deadlineDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
	return daysLeft <= 7;
};

/**
 * Formats a date-time string into MM/DD/YYYY H:MM AM/PM format
 * @param dateTime - Date-time string (can be ISO string, date string, or combined date-time)
 * @returns formatted date-time string or "N/A"
 */
export const formatDateTime = (dateTime: string): string => {
	if (!dateTime || dateTime === "N/A") return "N/A";

	try {
		const dateObj = new Date(dateTime);

		if (isNaN(dateObj.getTime())) return "N/A";

		const formattedDate = dateObj.toLocaleDateString("en-US", {
			month: "2-digit",
			day: "2-digit",
			year: "numeric",
		});

		const formattedTime = dateObj.toLocaleTimeString("en-US", {
			hour: "numeric",
			minute: "2-digit",
			hour12: true,
		});

		return `${formattedDate} ${formattedTime}`;
	} catch {
		return "N/A";
	}
};

export const formatTime = (dateTime: string): string => {
	if (!dateTime || dateTime === "N/A") return "N/A";

	try {
		const dateObj = new Date(dateTime);

		if (isNaN(dateObj.getTime())) return "N/A";

		// const formattedDate = dateObj.toLocaleDateString("en-US", {
		// 	month: "2-digit",
		// 	day: "2-digit",
		// 	year: "numeric",
		// });

		const formattedTime = dateObj.toLocaleTimeString("en-US", {
			hour: "numeric",
			minute: "2-digit",
			hour12: true,
		});

		return `${formattedTime}`;
	} catch {
		return "N/A";
	}
};

export const formatDatee = (dateTime: string): string => {
	if (!dateTime || dateTime === "N/A") return "N/A";

	try {
		const dateObj = new Date(dateTime);

		console.log(dateObj, "dateObj");

		if (isNaN(dateObj.getTime())) return "N/A";

		const formattedDate = dateObj.toLocaleDateString("en-US", {
			month: "2-digit",
			day: "2-digit",
			year: "numeric",
		});

		return `${formattedDate}`;
	} catch {
		return "N/A";
	}
};

export function extractInspectionValue(data: string, type: string) {
	if (!data) return null;

	if (type === "date" && data) {
		// Fix timezone issue by using local date methods instead of UTC
		const date = new Date(data);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		return `${year}-${month}-${day}`; // e.g., "2025-09-19"
	}

	if (type === "time" && data) {
		// Parse the UTC time string correctly
		const time = new Date(data);

		// Use UTC methods since the input is in UTC format
		let hours = time.getUTCHours(); // Use UTC hours for UTC input
		const minutes = time.getUTCMinutes().toString().padStart(2, "0"); // Use UTC minutes for UTC input

		// Calculate AM/PM
		const ampm = hours >= 12 ? "PM" : "AM";

		// Convert to 12-hour format
		if (hours === 0) {
			hours = 12; // 12 AM (midnight)
		} else if (hours > 12) {
			hours = hours - 12; // PM times
		}
		// AM times 1-11 stay the same

		return `${hours.toString()}:${minutes} ${ampm}`; // e.g., "7:33 PM"
	}

	return null;
}

export function calculateExperience(dateOfJoining: string | Date) {
	const joinDate = new Date(dateOfJoining);
	const today = new Date();

	let years = today.getFullYear() - joinDate.getFullYear();
	let months = today.getMonth() - joinDate.getMonth();

	// Adjust if the current month is before the joining month
	if (months < 0) {
		years--;
		months += 12;
	}

	// ✅ Handle less than a year
	if (years <= 0) {
		if (months <= 0) {
			return "0 months";
		}
		return `${months} month${months > 1 ? "s" : ""}`;
	}

	// ✅ Handle 1+ years (ignore months)
	return `${years} year${years > 1 ? "s" : ""}`;
}
